/**
 * Histórico de pedidos a proveedor: pedidos recibidos (el Listado queda con los en curso).
 * Al entrar: solo pedidos cerrados hoy (fecha_finalizado, o fecha del pedido si no tiene).
 * Filtros: fecha, rango, mes y proveedor.
 * Sin tope de mes (a diferencia del Histórico de Caja). Paginado de a 10 en el backend.
 */
import { applyHistoricoFecha, type HistoricoDateFilter } from "../CajaBancos/cajaHistorico";

export const PEDIDOS_HISTORICO_PAGE_SIZE = 10;

export function pedidosHistoricoDefaultFilter(todayYmd: string): HistoricoDateFilter {
  return applyHistoricoFecha({ fecha: "", desde: "", hasta: "", mes: "" }, todayYmd);
}

/** Como `applyHistoricoFecha`, pero borrar la fecha borra también el rango/mes ocultos. */
export function applyPedidosHistoricoFecha(
  prev: HistoricoDateFilter,
  fecha: string,
): HistoricoDateFilter {
  if (!fecha) return { fecha: "", desde: "", hasta: "", mes: "" };
  return applyHistoricoFecha(prev, fecha);
}

export type PedidosHistoricoParams = {
  historico: 1;
  fecha_desde?: string;
  fecha_hasta?: string;
  proveedor__codigo?: string;
  page: number;
  page_size: number;
};

export function pedidosHistoricoParams(
  filter: HistoricoDateFilter,
  proveedorCodigo: string,
  page: number,
): PedidosHistoricoParams {
  return {
    historico: 1,
    ...(filter.desde ? { fecha_desde: filter.desde } : {}),
    ...(filter.hasta ? { fecha_hasta: filter.hasta } : {}),
    ...(proveedorCodigo && proveedorCodigo !== "all"
      ? { proveedor__codigo: proveedorCodigo }
      : {}),
    page: Math.max(1, Math.floor(page) || 1),
    page_size: PEDIDOS_HISTORICO_PAGE_SIZE,
  };
}
